import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { validateNode } from "../helpers";
export const InfoUpdatePositions = Object.freeze({
    left: "left",
    center: "center",
    right: "right",
});
const InfoUpdate = ({ className, children, position }) => {
    const classes = classNames("gerudo-info-update", position ? ` ${position}` : "", className);
    return React.createElement("div", { className: classes }, validateNode(children));
};
InfoUpdate.defaultProps = {
    position: "left",
};
InfoUpdate.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
    position: PropTypes.oneOf(Object.values(InfoUpdatePositions)),
};
export default InfoUpdate;
export { InfoUpdate };
//# sourceMappingURL=index.js.map